<div class="topbar-actions">
  <app-button variant="primary" [width]="147" size="small" [loading]="buttonLoading()" (click)="buttonClick.emit()">
    <span class="topbar-actions__label body-sm-regular">
      <app-icon [src]="buttonIcon()" [size]="16"></app-icon>
      {{ buttonLabel() }}
    </span>
  </app-button>
</div>
